export const navLinks = [
  { label: "专题合集", href: "#topics" },
  { label: "深度调查", href: "#investigation" },
  { label: "黑产图谱", href: "#chain" },
  { label: "风险预警", href: "#alerts" },
  { label: "实锤材料", href: "#evidence" },
  { label: "爆料通道", href: "#desk" },
];

export const heroStats = [
  { value: "1,286", label: "已核验线报" },
  { value: "37", label: "覆盖产业链环节" },
  { value: "214", label: "公开实锤材料" },
  { value: "072", label: "期专题合集" },
];

export const heroTags = [
  "黑灰产",
  "黑色产业链",
  "暗黑交易",
  "地下市场",
  "黑市信息",
  "资金通道",
];

export const topics = [
  {
    no: "01",
    tag: "数据黑市",
    title: "数据黑市交易链",
    desc: "从社工库兜售、撞库洗库到精准画像买卖，拆解个人信息如何被层层加价转手。",
    count: "38 篇材料",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20still%20life%20of%20a%20glowing%20server%20rack%20wrapped%20in%20heavy%20chains%20with%20scattered%20encrypted%20hard%20drives%20on%20a%20black%20table%20crimson%20rim%20light%20moody%20investigative%20style%20deep%20shadows%20minimal%20composition%20no%20text&width=800&height=600&seq=hw-topic-data-11&orientation=landscape",
  },
  {
    no: "02",
    tag: "资金通道",
    title: "跑分与洗钱闭环",
    desc: "追踪第四方支付、虚拟币混币与跨境对敲，把一笔来路不明的钱洗白的完整路径。",
    count: "27 篇材料",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20scene%20of%20coins%20and%20faceless%20ledger%20sheets%20dissolving%20into%20digital%20particles%20above%20a%20black%20surface%20amber%20and%20red%20glow%20ominous%20mood%20stylized%20conceptual%20illustration%20minimal%20no%20text&width=800&height=600&seq=hw-topic-money-12&orientation=landscape",
  },
  {
    no: "03",
    tag: "诈骗园区",
    title: "网络诈骗工厂",
    desc: "园区招募话术、业绩考核表与被骗者口述，还原流水线式诈骗的每一个工位。",
    count: "45 篇材料",
    image:
      "https://readdy.ai/api/search-image?query=dark%20abstract%20illustration%20of%20endless%20rows%20of%20empty%20office%20desks%20lit%20by%20cold%20monitors%20behind%20frosted%20glass%20silhouette%20atmosphere%20crimson%20and%20amber%20accent%20light%20industrial%20mood%20minimal%20no%20text%20no%20faces&width=800&height=600&seq=hw-topic-fraud-13&orientation=landscape",
  },
  {
    no: "04",
    tag: "地下市场",
    title: "地下博彩代理网",
    desc: "层层代理、后台改单与提现话术，看清庄家如何一步步把正常人锁成输家。",
    count: "19 篇材料",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20composition%20of%20dice%20and%20playing%20cards%20half%20submerged%20in%20shadow%20with%20red%20neon%20reflections%20smoky%20atmosphere%20conceptual%20still%20life%20high%20contrast%20minimal%20no%20text&width=800&height=600&seq=hw-topic-betting-14&orientation=landscape",
  },
  {
    no: "05",
    tag: "工具链",
    title: "灰产工具供应链",
    desc: "群控、改机、接码与养号工具链，究竟是谁在源源不断给黑产供应弹药。",
    count: "31 篇材料",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20visualization%20of%20interconnected%20gears%20and%20circuit%20lines%20forming%20a%20hidden%20network%20charcoal%20background%20with%20amber%20and%20crimson%20highlights%20mechanical%20investigative%20mood%20minimal%20no%20text&width=800&height=600&seq=hw-topic-tools-15&orientation=landscape",
  },
];

export const features = [
  {
    tag: "深挖",
    date: "2026.08.19",
    readTime: "18 分钟",
    title: "我们潜伏了三个月的接码平台：一条验证码只值 1.7 元",
    excerpt:
      "从卡商到平台再到下游养号团伙，一条验证码背后是一整条被明码标价的灰色流水线，我们记录下了它的价目表和分工。",
    image:
      "https://readdy.ai/api/search-image?query=dark%20editorial%20still%20life%20of%20a%20broken%20padlock%20resting%20on%20a%20stack%20of%20blank%20documents%20under%20a%20single%20beam%20of%20amber%20light%20deep%20charcoal%20background%20mysterious%20investigative%20mood%20high%20contrast%20minimal%20no%20text&width=1200&height=800&seq=hw-feature-code-21&orientation=landscape",
  },
  {
    tag: "预警",
    date: "2026.07.30",
    readTime: "12 分钟",
    title: "以「客服退款」为幌子的二次诈骗，正盯上被骗过的人",
    excerpt:
      "上一笔损失还没追回，新的电话就来了。骗子手里握着精确的受害名单，二次收割比第一次更狠，也更难被识破。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20noir%20abstract%20scene%20of%20a%20distant%20anonymous%20silhouette%20in%20a%20rain%20soaked%20empty%20alley%20with%20reflections%20of%20red%20signage%20heavy%20fog%20deep%20shadows%20minimal%20composition%20no%20text%20no%20distinct%20faces&width=1200&height=800&seq=hw-feature-refund-22&orientation=landscape",
  },
  {
    tag: "追踪",
    date: "2026.06.11",
    readTime: "22 分钟",
    title: "虚拟币混币服务调查：洗白一笔赃款的成本与路径",
    excerpt:
      "手续费、时间窗口与拆分策略共同决定了一笔黑钱的「清白度」。我们按公开材料复算了三种常见混币路线。",
    image:
      "https://readdy.ai/api/search-image?query=dark%20conceptual%20still%20life%20of%20a%20burner%20phone%20and%20tangled%20charging%20cables%20on%20a%20rough%20concrete%20floor%20crimson%20side%20light%20gritty%20investigative%20mood%20deep%20shadows%20minimal%20no%20text&width=1200&height=800&seq=hw-feature-mix-23&orientation=landscape",
  },
];

export const chainStages = [
  {
    stage: "上游",
    title: "物料与工具供给",
    desc: "黑产的第一层，负责把「弹药」准备好，再批发给中游的操盘手。",
    items: ["社工库与泄露数据", "接码与注册工具", "改机群控设备", "虚假实名账号"],
  },
  {
    stage: "中游",
    title: "运营与引流转化",
    desc: "把工具和账号变成「业务」，用话术、投放和组织管理把流量榨成流水。",
    items: ["话术剧本与培训", "引流投放与私域", "客服与改单后台", "园区组织与考核"],
  },
  {
    stage: "下游",
    title: "变现与资金清洗",
    desc: "最隐蔽的一层，负责把赃款拆散、转移、混币，最后落回正常的经济循环。",
    items: ["跑分与第四方支付", "虚拟币混币对敲", "地下钱庄结算", "赃款消费与转移"],
  },
];

export const alerts = [
  {
    level: "高危",
    date: "2026.09.08",
    title: "仿冒「国家反诈」App 的新木马正在短信渠道批量传播",
    brief: "伪装成官方预警工具，诱导输入银行卡与验证码，已有多地线人反馈收到同类短信。",
  },
  {
    level: "关注",
    date: "2026.09.03",
    title: "境外号码以「快递理赔」为名索要屏幕共享权限",
    brief: "一旦开启共享，对方可实时读取银行 App 验证码，属于近期上升最快的诈骗话术。",
  },
  {
    level: "高危",
    date: "2026.08.26",
    title: "打着「兼职刷单」旗号的跑分招募，转向学生与宝妈群体",
    brief: "先小额返利建立信任，再诱导垫资，实质是让参与者成为洗钱链条的一环。",
  },
  {
    level: "提示",
    date: "2026.08.14",
    title: "低价代充与「内部折扣」交易，多来源不明黑卡充值",
    brief: "折扣越低风险越高，充值来源一旦涉案，账号余额可能被平台直接冻结回收。",
  },
];

export const evidenceFiles = [
  { code: "HJ-2026-0187", type: "后台截图", date: "2026.08.24", title: "某跑分平台结算后台导出画面", source: "线人投稿" },
  { code: "HJ-2026-0164", type: "聊天记录", date: "2026.08.06", title: "园区招工群完整话术与分成表", source: "内部流出" },
  { code: "HJ-2026-0151", type: "转账凭证", date: "2026.07.27", title: "一起二次诈骗的收款流水记录", source: "受害者提供" },
  { code: "HJ-2026-0138", type: "价目表", date: "2026.07.09", title: "接码平台的套餐与批发报价单", source: "线人投稿" },
  { code: "HJ-2026-0122", type: "工具说明", date: "2026.06.21", title: "群控改机软件的授权与分销文档", source: "技术线人" },
  { code: "HJ-2026-0109", type: "域名清单", date: "2026.06.02", title: "一批镜站与跳转域名的轮换规律", source: "多方核验" },
];

export const deskChannels = [
  {
    icon: "ri-mail-send-line",
    title: "加密邮箱投递",
    value: "tips@heiwang.example",
    desc: "支持附带图片、录音与文档，建议先脱敏再发送。",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "端到端加密频道",
    value: "@heiwang_desk",
    desc: "适合需要持续沟通的长线爆料，可协商验证材料真伪。",
  },
  {
    icon: "ri-file-shield-2-line",
    title: "材料核验窗口",
    value: "每期开放 72 小时",
    desc: "对无法核实的材料，我们只会标注存疑，不会直接公开。",
  },
];

export const footerColumns = [
  {
    title: "专题合集",
    links: ["数据黑市交易链", "跑分与洗钱闭环", "网络诈骗工厂", "地下博彩代理网", "灰产工具供应链"],
  },
  {
    title: "栏目索引",
    links: ["深度调查", "黑产图谱", "风险预警", "实锤材料库", "爆料通道"],
  },
  {
    title: "关于我们",
    links: ["编辑部说明", "核验标准", "隐私与安全", "纠错与反馈", "转载与合作"],
  },
];